<template>
  <v-container class="controllers" fluid>
    <v-row align="center">
      <v-col cols="auto">
        <h1>{{ $route.meta.title }}</h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-menu
          bottom
          left
          offset-y
          origin="right right"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              outlined
              class="text-none mr-2"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Скачать отчёт
            </v-btn>
          </template>
          <v-list width="360" dense>
            <v-list-item>
              <v-btn
                color="primary"
                outlined
                class="text-none mr-2"
                rounded
                disabled
              >
                Полный отчёт
              </v-btn>
              <v-btn
                color="primary"
                outlined
                class="text-none mr-2"
                dark
                rounded
                @click.prevent="downloadReportPage()"
              >
                Отчёт на странице
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          color="primary"
          class="text-none mr-2"
          dark
          to="/controller/new"
        >
          Новый контроллер
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="center">
      <div class="filters-controllers">
        <v-text-field
          @keyup="validateKeyUp"
          placeholder="Улица"
          v-model="filterAddress"
          outlined
          dense
          hide-details
          style="max-width: 280px"
          prepend-inner-icon="mdi-rename-box-outline"
          class="input input-search pl-3 shrink mb-1"
        />
        <v-autocomplete
          placeholder="Статус"
          item-text="text"
          :items="sipSelectList"
          v-model="sipStatusSearched"
          item-value="value"
          prepend-inner-icon="mdi-progress-clock"
          style="max-width: 280px"
          outlined
          dense
          hide-details
          clearable
          class="pl-3 shrink mb-1"
        >
        </v-autocomplete>
        <v-autocomplete
          label="Агент"
          v-model="filterAgent"
          v-if="disableFilterName"
          :items="agents"
          item-text="user.name"
          item-value="id"
          style="max-width: 280px"
          prepend-inner-icon="mdi-account-search"
          class="pl-3 shrink mb-1"
          outlined
          dense
          hide-details
          clearable
        >
        </v-autocomplete>
        <div>
          <v-btn
            dark
            @click.prevent="filterControllers"
            v-if="!isBtnFiltersSmall"
            class="btn blue darken-3 white px-7 text-none ml-2"
          >
            Поиск
          </v-btn>
        </div>
      </div>
      <v-btn
        dark
        v-if="isBtnFiltersSmall"
        class="btn blue darken-3 white px-7 text-none ml-2 mb-2"
      >
        Поиск
      </v-btn>
    </v-row>
    <v-card flat class="mt-4">
      <v-data-table
        class="table row-click"
        :headers="headersControllers"
        :items="controllers"
        :options.sync="options"
        :server-items-length="totalControllers"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100, 500],
          showFirstLastPage: true,
        }"
        @click:row="rowDetailController"
      >
        <template v-slot:item.created_at="{ item }" v-if="!isDisplaySmall">
          {{ ruDateFormat(item.created_at) }}
        </template>
        <template v-slot:item.sipStatus="{ item }" v-if="!isDisplaySmall">
          <div>
            <v-icon x-small :color="item.sip_status_color">
              mdi-checkbox-blank-circle
            </v-icon>
            {{ item.sip_status_text }}
          </div>
        </template>
        <template v-slot:body v-if="isDisplaySmall">
          <tbody class="table" v-if="controllers[0]">
          <tr
            v-for="(item, index) in controllers" :key="index"
            @click.middle="clickControllerWhell(item.id)"
            @click.prevent="clickController($event, item.id)"
          >
            <td>{{ item.id }}</td>
            <td>{{ item.address }}</td>
            <td>{{ item.name }}</td>
            <td>{{ ruDateFormat(item.created_at) }}</td>
            <td>{{ item.agent }}</td>
            <td>
              <div>
                <v-icon x-small :color="item.sip_status_color">
                  mdi-checkbox-blank-circle
                </v-icon>
                {{ item.sip_status_text }}
              </div>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="10" style="text-align: center">Отсутствуют данные</td>
          </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  name: 'Controllers',
  mixins: [ruDateFormatMixin],
  data () {
    return {
      isCreated: false,
      filters: {},
      sipStatusSearched: '',
      disableRoleName: false,
      filterAddress: '',
      filterAgent: '',
      isBtnFiltersSmall: false,
      isDisplaySmall: true,
      disableFilterName: true,
      totalControllers: 0,
      filterType: '',
      options: {
        itemsPerPage: 20,
        page: 1,
      },
      sipSelectList: [
        { text: 'Отключен', value: '0' },
        { text: 'Регистрация', value: '1' },
        { text: 'Зарегистрирован', value: '2' },
        { text: 'Не удалось зарегистрироваться', value: '3' },
        { text: 'Не установлен', value: '4' },
        { text: 'Без интернет соединения', value: '5' },
        { text: 'Пусконаладка', value: '6' },
        { text: 'Старый домофон', value: '7' },
        { text: 'Не в сети', value: 'null' },
        { text: 'Не зарегистрирован', value: '-1' },
      ],
    };
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadControllers();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  created () {
    this.isCreated = true;
    if (Object.keys(this.$route.query).length) {
      const routeQuery = this.$route.query;

      if (routeQuery.address) {
        this.filterAddress = routeQuery.address;
        this.filters.address = routeQuery.address;
      }
      if (routeQuery.agent_id) {
        this.filterAgent = routeQuery.agent_id;
        this.filters.agent_id = routeQuery.agent_id;
      }
      if (routeQuery.status) {
        this.sipStatusSearched = routeQuery.status;
        this.filters.status = routeQuery.status;
      }
    }
    switch (this.roleName) {
      case 'call-center' : case 'manager' : this.disableFilterName = false;
        break;
    }
    // this.loadAllAgents();
    this.loadControllers();
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      controllers: 'Controllers/controllers',
      agents: 'Agents/agents',
    }),
    headersControllers () {
      return [
        {
          text: 'id',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Адрес',
          value: 'address',
          width: '26%',
          sortable: false,
        },
        {
          text: 'Название',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Дата и время создания',
          value: 'installed_at',
          sortable: false,
        },
        {
          text: 'agent',
          value: 'agent',
          sortable: false,
        },
        {
          text: 'Статус',
          value: 'sipStatus',
          width: '13%',
          sortable: false,
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      loadAllControllers: 'Controllers/loadAllControllers',
      loadAllAgents: 'Agents/loadAllAgents',
    }),
    checkSize () {
      this.isBtnFiltersSmall = window.innerWidth <= 600;
      this.isDisplaySmall = window.innerWidth >= 600;
    },
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterControllers();
      }
    },
    clickController (event, value) {
      if (this.$canRoute('DetailController')) {
        if (event.ctrlKey) {
          this.clickControllerWhell(value);
        } else {
          this.detailController(value);
        }
      }
    },
    clickControllerWhell (id) {
      const routeData = this.$router.resolve({ name: 'DetailController', params: { id: id } });
      window.open(routeData.href, '_blank');
    },
    detailController (value) {
      let { id } = value;
      if (!id) {
        id = value;
      }
      this.$router.push({ name: 'DetailController', params: { id: id } });
    },
    rowDetailController (value) {
      if (!this.isDisplaySmall) {
        this.detailController(value);
      }
    },
    downloadReportPage () {
      const lines = [];
      this.controllers.forEach((item) => {
        const createdAt = this.ruDateFormat(item.created_at, true);
        const line = [
          item.id, item.address, item.name, createdAt, item.agent, item.sip_status_text,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'Controllers.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    encodeCP1251 (string) {
      function encodeChar (c) {
        const isKyr = function (str) {
          return /[а-я]/i.test(str);
        };
        // eslint-disable-next-line no-multi-str
        const cp1251 = 'ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬*®Ї°±Ііґµ¶·\
ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя';
        const p = isKyr(c) ? (cp1251.indexOf(c) + 128) : c.charCodeAt(0);
        let h = p.toString(16);
        if (h === 'a') {
          h = '0A';
        }
        return '%' + h;
      }
      let res = '';
      for (let i = 0; i < string.length; i++) {
        res += encodeChar(string.charAt(i));
      }
      return res;
    },
    filterControllers () {
      this.options.page = 1;
      this.filters = {};

      if (this.filterAddress) {
        this.filters.address = this.filterAddress;
      }
      if (this.sipStatusSearched) {
        this.filters.status = this.sipStatusSearched;
      }
      if (this.filterAgent) {
        this.filters.agent_id = this.filterAgent;
      }
      this.$router.push({
        query: {
          address: this.filters.address,
          status: this.filters.status,
          agent: this.filters.agent_id,
        },
      }).catch(() => {});
      this.loadControllers();
    },
    loadControllers () {
      this.$router.push({
        query: {
          address: this.filters.address,
          status: this.filters.status,
          agent: this.filters.agent_id,
        },
      }).catch(() => {});
      this.loadAllControllers({
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
      })
        .then((response) => {
          this.totalControllers = response.meta.total;
        })
        .catch((error) => {
          console.error(error);
          this.$sentry_exception(error);
          this.$flash_warning('Ошибка при загрузке');
        });
    },
  },
};
</script>

<style>
.filters-controllers {
  display: flex;
  grid-row-gap: 5px;
  margin-bottom: 15px;
}
.row-click {
  cursor: pointer;
}
.input {
&-search {
   max-width: 301px;
   width: 100%;
 }
}

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
@media screen and (max-width: 600px) {
  .filters-controllers {
    display: block;
  }
}
</style>
